import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { CircularProgress } from '@material-ui/core';
import InputSearch from './components/InputSearch';
import DataTable from './components/DataTable';
import Pagination from './components/Pagination';
import Backdrop from '~/components/BackdropComponent';
import SubTitle from '~/components/SubTitle';
import { errorMessage } from '~/utils/Message';

import api from '~/services/api';

import { Container } from './styles';

function Search() {
  const profile = useSelector((state) => state.user.profile);
  const hemocenter_id = profile.hemocenter ? profile.hemocenter.id : undefined;

  const [searchText, setSearchText] = useState('');
  const [patients, setPatients] = useState([]);
  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const loadPatients = useCallback(
    async (search = undefined, page = 1) => {
      setLoading(true);

      try {
        const { data } = await api.get('/patients', {
          params: {
            page,
            pageSize: 10,
            search,
            hemocenter_id,
          },
        });

        setCurrentPage(page);
        setPatients(data.patients);
        setPages(data.pages);
      } catch (error) {
        errorMessage(error);
      } finally {
        setLoading(false);
      }
    },
    [hemocenter_id]
  );

  useEffect(() => {
    document.title = 'Buscar pacientes | ClickHemofilia';
  }, []);

  useEffect(() => {
    loadPatients();
  }, [loadPatients]);

  return (
    <Container>
      <SubTitle>Busca de pacientes</SubTitle>

      <InputSearch
        searchText={searchText}
        setSearchText={setSearchText}
        handleSubmit={loadPatients}
      />

      <DataTable data={patients} />

      <Pagination
        searchText={searchText}
        page={currentPage}
        count={pages}
        handlePage={loadPatients}
      />

      <Backdrop open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}

export default Search;
